<template>
  <div v-if="surveydata">
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6"></div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <h3 v-if="!isPhone" v-html="surveydata.misc.surveyHeader"></h3>
          <div class="card text-left" v-for="(srv, idx) in matchingSurveys" :key="'srv' + idx">
            <div v-for="(srvOpt, idx) in srv.surveyOptions" :key="'srvOpt' + idx">
              <h4 class="srvopt-question" v-html="srvOpt.question"></h4>
              <span class="badge badge-primary" v-html="surveydata.misc.questionBadge"
                v-if="hasProp(srvOpt, 'question')"></span>
              <hr v-if="hasProp(srvOpt, 'question')" />
              <span v-html="srvOpt.questionLabel"></span>
              <!-- Generella frågor -->
              <div class="form-check" v-if="!hasProp(srvOpt, 'question') && srv.surveyId !== '132813328'">
                <input class="form-check-input" type="radio"
                  @input="addReplaceAnswersRadio({ id: srv.surveyId, l: srvOpt.label, a: parseInt(srvOpt.value) })"
                  :name="srv.surveyId" :id="srv.surveyId + idx">
                <label v-html="srvOpt.label" class="form-check-label"
                  :for="srv.surveyId + idx"></label>
              </div>
              <!-- Opt-out -->
              <div class="form-check" v-if="!hasProp(srvOpt, 'question') && srv.surveyId === '132813328'">
                <input class="form-check-input" type="checkbox"
                  @input="addReplaceAnswersCheckbox({ id: srv.surveyId, l: srvOpt.label, a: parseInt(srvOpt.value) }, $event)"
                  :name="srv.surveyId" :id="srv.surveyId + idx">
                <label v-html="srvOpt.label" class="form-check-label"
                  :for="srv.surveyId + idx"></label>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- Generella frågor -->
          <button class="btn btn-consent btn-primary btn-lg btn-block"
            data-toggle="modal" data-target="#preview" v-if="matchingSurveys.length > 0
              && matchingSurveys.some(ms => ms['surveyId'] !== '132813328')"
            :disabled="answers.length !== matchingSurveys.length" v-html="surveydata.misc.previewAnswersBtn"></button>
          <!-- Opt-out -->
          <button class="btn btn-consent btn-primary btn-lg btn-block"
            data-toggle="modal" data-target="#preview" v-if="matchingSurveys.length === 1
              && matchingSurveys[0].surveyId === '132813328'"
            :disabled="answers.length !== 0" v-html="surveydata.misc.previewAnswersBtn"></button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <!-- Modal - Preview -->
    <div id="preview" class="modal fade" role="dialog" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <h4 v-html="surveydata.misc.previewAnswersBtn"></h4>
            <hr />
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <div class="text-left" v-for="(answ, idx) in answers" :key="'answ' + idx">
              <strong v-html="surveydata.misc.questionBadge"></strong>: {{ getMatchingSurveyQuestion(answ.id) }}
              <br />
              <strong v-html="surveydata.misc.answerBadge"></strong>: {{ answ.l }}
              <div class="clearfix"></div>
            </div>
            <button class="btn btn-primary btn-block" @click="confirmAnswers">Bekräfta svar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../config/index.js'
import axios from '../plugins/axios'
import { request } from '../plugins/datocms'
import { isMobile } from 'mobile-device-detect'
import { showDelayText } from '../plugins/delayhandler'

export default {
  name: 'survey',
  props: ['questionId'],
  components: {},
  data () {
    return {
      surveydata: null,
      answers: [],
      questions: null,
      isPhone: isMobile
    }
  },
  methods: {
    todoAlert (str) {
      alert(str)
    },
    hasProp (obj, prop) {
      return obj.hasOwnProperty(prop)
    },
    getMatchingSurveyQuestion (id) {
      const question = this.matchingSurveys
        .filter(ms => ms.surveyId === id)[0].surveyOptions
        .find(so => so.question).question
      return question
    },
    addReplaceAnswersRadio (evt) {
      if (this.answers.some(answ => answ['id'] === evt.id)) {
        this.answers = this.answers.filter(answ => answ['id'] !== evt.id)
      }
      this.answers.push(evt)
    },
    addReplaceAnswersCheckbox (evt, event) {
      if (event.target.checked) {
        this.answers.push(evt)
      } else {
        this.answers = this.answers.filter(answ => answ['a'] !== evt.a)
        console.log(this.answers)
      }
    },
    confirmAnswers () {
      const r = confirm(this.surveydata.misc.areYouSureText)
      if (r) {
        this.sendAnswers()
      }
    },
    sendAnswers (_answer) {
      if (_answer !== null) {
        let loader = this.$loading.show({
          default: showDelayText(config.delayText, config.delayTimer)
        })
        const answer = {
          question: this.$refs.scrQuestion.firstChild.innerText,
          answer: _answer,
          timestamp: new Date().toLocaleString('sv-SE', { timeZone: 'CET' })
        }
        axios.postScreeningAnswer(config.screeningAnswerUri, JSON.stringify(answer), parseInt(this.fieldId)).then((response) => {
          if (response.status === 200) {
            loader.hide()
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    }
  },
  beforeMount () {
    if (this.$route.query && this.$route.query.questions) {
      this.questions = this.$route.query.questions.split(',').filter(i => i)
    } else if (this.$props.questionId) {
      this.questions = this.$props.questionId
    }
  },
  computed: {
    ages0to100 () {
      return Array.from({length: 101}, (_, i) => i)
    },
    matchingSurveys () {
      return this.surveydata.allSurveys.filter(s => this.questions.includes(s.surveyId))
    }
  },
  async mounted () {
    this.surveydata = await request({
      query: `
        {
          allSurveys(first: 100) {
            surveyId
            surveyOptions {
              ... on OptionRecord {
                label
                value
              }
              ... on QuestionRecord {
                question
                questionLabel
              }
            }
          }
          misc {
            areYouSureText
            surveyHeader
            questionBadge
            answerBadge
            previewAnswersBtn
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h4 {
  margin-top: 5px;
}
.card {
  padding: 15px;
  min-height: auto;
  border-radius: 20px;
}
.card .badge {
  margin: 10px;
  position: absolute;
  top: 0px;
  right: 0px;
}
.container {
  margin-top: 5vh !important;
  padding-bottom: 5vh !important;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .container {
    margin-top: 10vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Survey.vue